import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchLeaderboard, getOrCreateUserId } from "../lib/api";

export default function Leaderboard() {
  const nav = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const me = getOrCreateUserId();

  useEffect(() => {
    (async () => {
      try { setList(await fetchLeaderboard(50)); } catch (e) { console.error(e); }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="min-h-screen w-full px-4 py-6 md:py-16 flex flex-col items-center">
      <div className="max-w-3xl w-full">
        <div className="flex items-center justify-between gap-2 mb-6 md:mb-8 flex-wrap">
          <h1 className="font-display font-black text-2xl md:text-5xl">Leaderboard</h1>
          <button className="btn-ghost" onClick={() => nav("/")} data-testid="lb-back-btn">Back</button>
        </div>
        <div className="glass rounded-3xl p-4 md:p-6">
          {loading ? (
            <div className="text-white/50 text-center py-10">Loading…</div>
          ) : list.length === 0 ? (
            <div className="text-white/50 text-center py-10">Be the first to make the board.</div>
          ) : (
            <div className="divide-y divide-white/10">
              {list.map((p, i) => {
                const isMe = p.user_id === me;
                return (
                  <div key={p.user_id}
                    className={`flex items-center justify-between py-3 ${isMe ? "rounded-xl" : ""}`}
                    style={{ background: isMe ? "rgba(255,215,0,0.07)" : "transparent", padding: isMe ? "12px" : undefined }}
                    data-testid={`lb-row-${i}`}
                  >
                    <div className="flex items-center gap-4">
                      <span className="font-mono w-8 text-white/60">#{i + 1}</span>
                      <div>
                        <div className="font-display font-bold">{p.name}{isMe ? " (you)" : ""}</div>
                        <div className="label-eyebrow" style={{ fontSize: 9 }}>LV {p.level} · {p.wins}W / {p.losses}L</div>
                      </div>
                    </div>
                    <span className="font-mono font-bold" style={{ color: "#FFD700" }}>◆ {p.chips.toLocaleString()}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
